import { useEffect, useState } from 'react';
import xxhash from 'xxhash-wasm';

const useHashGenerator = (plainText: string | undefined) => {
  const [hash, setHash] = useState<string | null>(null);
  const [isHashLoading, setIsHashLoading] = useState(true);

  useEffect(() => {
    if (!plainText) {
      setHash(null);
      setIsHashLoading(false);
      return;
    }

    const loadHash = async () => {
      const hasher = await xxhash();

      const result = hasher.h64ToString(plainText);
      setHash(result);
      setIsHashLoading(false);
    };

    loadHash();
  }, [plainText]);

  return { hash, isHashLoading };
};

export default useHashGenerator;
